const SIMPLE_REFERENCE_PATTERN = /^[A-Za-z_][A-Za-z0-9_]*$/;

export function unescapeTransformScriptReference(value: string) {
  return value.replace(/\\([\\{}])/g, "$1").trim();
}

export function parseTransformScriptReference(raw: string) {
  if (!raw.startsWith("$")) {
    return raw;
  }

  if (raw.startsWith("${") && raw.endsWith("}")) {
    return unescapeTransformScriptReference(raw.slice(2, -1));
  }

  return raw.slice(1).trim();
}

export function escapeTransformScriptReferenceName(value: string) {
  return value.trim().replace(/[\\{}]/g, (char) => `\\${char}`);
}

export function formatTransformScriptReference(value: string) {
  const normalized = value.trim();

  if (SIMPLE_REFERENCE_PATTERN.test(normalized)) {
    return `$${normalized}`;
  }

  return `\${${escapeTransformScriptReferenceName(normalized)}}`;
}
